import { useNavigate } from "react-router-dom";
import { FaFileInvoiceDollar } from "react-icons/fa";
import "./FloatingQuoteButton.css";

export default function FloatingQuoteButton() {
  const navigate = useNavigate();

  return (
    <button
      className="floating-quote-btn"
      onClick={() => navigate("/quote-request")}
    >
      <span>GET QUOTE</span>
    </button>
  );
}